import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationEnd } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

  private capabilities = {
    articles: true,
    candidates: true,
    chat: true,
    dashboard: true,
    events: false,
    polls: true,
    profile: true,
    recruiting: true,
    reports: true,
    webinars: true,
    career_days: true,
    dataloop: true
  }

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const token = localStorage.getItem('token');
    if (token) {
      const userData = JSON.parse(localStorage.getItem('userData'));
      const teams_id = localStorage.getItem('teams_id');

      if (!userData || !teams_id) {
        this.router.navigate(['/login']);
        return false;
      } else {
        // logged in so i can check this user's capabilities
        if (this.checkCapabilities(state.url)) {
          return true;
        } else {
          for (const c in userData['OperatorCapability']) {
            if (userData['OperatorCapability'][c] === true) {
              this.router.navigate(['/' + c]);
            }
          }
        }
        return this.checkCapabilities(state.url);
      }
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

  checkCapabilities(url): boolean {
    let root = url.split('/')[1];
    // FIX-ME CHECK
    if (root === 'login' || root === 'pdf-download') { return true; }
    if (localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))['OperatorCapability']) {
      this.capabilities = JSON.parse(localStorage.getItem('userData'))['OperatorCapability'];
      // FIX-ME comment below when ready
      // this.capabilities['digital-career-days'] = true;
    }

    if (root === 'experiences') {
      root = 'webinars';
    }

    return this.capabilities[root];
  }


}
